import axios from "axios";
import { deruptInterfaceAddress, stacksApi, clientNetwork } from "../lib/constants";
import { cvToJSON, hexToCV } from "@stacks/transactions";
import { getUserData } from "./auth";

export async function getinterfaceCost() {
    try {
        const userAddress = getUserData().profile.stxAddress.testnet;
        //const userAddress = getUserData().profile.stxAddress.mainnet;
        const args = JSON.stringify({ "sender": userAddress, "arguments": [] });
        const config = {
            method: 'post', maxBodyLength: Infinity,
            url: `${stacksApi}/v2/contracts/call-read/${deruptInterfaceAddress.split('.')[0]}/${deruptInterfaceAddress.split('.')[1].split('::')[0]}/get-costs`,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: args
        };
        const res = (await axios.request(config)).data.result;
        console.log(res)
        const { value: { value } } = cvToJSON(hexToCV(res))
        console.log(value);
        return value
    } catch (error) {
        return
    }
}